export default __webpack_public_path__ + "static/media/mode-50.bfd66cf6.svg";